import { useState } from "react";
import { Container, Row, Col, Modal, ModalBody, ModalHeader } from "reactstrap";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { DOCUMENTS_EXE_ICONS } from "../../../Data/documentsExtensionIcon";
import FileViewer from "../../template/file-viewer/FileViewer";
import DocumentCard from "./document-card/documentCard";
import styles from "./documents.module.scss";
import DocumentList from "./document-list/documentList";
import AddSupport from "../../Support/add-support/addSupport";
import { SupportDto } from "../../../models/supportDto";
import { StatisticMediaDto } from "../../../models/statisticMediaDto";
import { ACTION } from "../../../models/action";
import hasRoles from "../../../security/hasRoles";
import keycloak from "../../../security/keycloak-config";

const Documents: React.FC<{
  t: (key: string) => {};
  filteredDocuments: SupportDto[];
  isListDisplayMode: boolean;
  categoryId: number;
  handleGetListSupport: () => void;
  paginateAndSorting: (index: number, e: any) => void;
  setSortColumn: (sortColumn: string) => void;
  setSortOrder: (sortOrder: string) => void;
  setFilteredDocuments: (support: SupportDto[]) => void;
  resetAllFieldSearch: () => void;
  currentPage: number;
  elementPerPage: number;
  path: string;
}> = props => {
  const hasRoleAdmin = hasRoles(["ROLE_MEDIATHEQUE_ADMIN"], keycloak);
  toast.configure();
  const httpClient = useHttpClient(false);
  const [urlSupport, setUrlSupport] = useState<string>("");
  const [openModalEditSupport, setOpenModalEditSupport] = useState<boolean>(false);
  const [openModalViewer, setOpenModalViewer] = useState<boolean>(false);
  const [editSupport, setEditSupport] = useState<SupportDto>();

  const getDocumentIconFromExtension = (path: string): any => {
    return DOCUMENTS_EXE_ICONS.get(path.slice(path.lastIndexOf(".") + 1, path.length));
  };

  const handleClickOpenModalViewer = (data: SupportDto): void => {
    setUrlSupport(data?.urlSupport);
    if (!openModalViewer) {
      if (!hasRoleAdmin) {
        let statisticMediaDto = new StatisticMediaDto();
        statisticMediaDto.categoryId = data.categoryId;
        statisticMediaDto.typeCategory = "0";
        statisticMediaDto.mediaId = data.supportId;
        statisticMediaDto.action = ACTION.VIEW;
        httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
      }
      setOpenModalViewer(!openModalViewer);
    } else {
      setOpenModalViewer(!openModalViewer);
    }
  };
  const handleDownloadDocument = (data: SupportDto) => {
    if (!hasRoleAdmin) {
      let statisticMediaDto = new StatisticMediaDto();
      statisticMediaDto.categoryId = data.categoryId;
      statisticMediaDto.typeCategory = "0";
      statisticMediaDto.mediaId = data.supportId;
      statisticMediaDto.action = ACTION.DOWNLOAD;
      httpClient.current?.post("statistic_media", statisticMediaDto).then(response => {});
    }
  };

  const handleDeleteSUpport = (supportId: number): void => {
    SweetAlert.fire({
      title: props.t("message_confirmation_delete_pdf"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/support/" + supportId).then(() => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          handleGetListSupport();
          resetAllFieldSearch();
        });
      }
    });
  };

  const handleGetListSupport = (): void => {
    props.handleGetListSupport();
  };

  const resetAllFieldSearch = () => {
    props.resetAllFieldSearch();
  };

  const handleClickOpenModalEditSupport = (data: SupportDto): void => {
    setEditSupport(data);
    setOpenModalEditSupport(!openModalEditSupport);
  };

  return (
    <Container className={styles["documents-wrapper"]} fluid>
      <Row>
        <Col md={12} xl={12}>
          {!props.filteredDocuments.length && <div className="text-center">{props.t("message_no_document")}</div>}
          {props.filteredDocuments.length > 0 && (
            <Row>
              {props.isListDisplayMode &&
                props.filteredDocuments.map((data: SupportDto, index: number) => (
                  <Col sm={12} md={6} xl={3} key={data.supportId}>
                    <DocumentCard
                      data={data}
                      handleClickOpenModalViewer={handleClickOpenModalViewer}
                      handleClickOpenModalEditSupport={handleClickOpenModalEditSupport}
                      handleDeleteSUpport={handleDeleteSUpport}
                      getDocumentIconFromExtension={getDocumentIconFromExtension}
                      handleDownloadDocument={handleDownloadDocument}
                    />
                  </Col>
                ))}
            </Row>
          )}

          {!props.isListDisplayMode && props.filteredDocuments.length > 0 && (
            <Row>
              <Col md={12}>
                <DocumentList
                  data={props.filteredDocuments}
                  handleDownloadDocument={handleDownloadDocument}
                  handleClickOpenModalViewer={handleClickOpenModalViewer}
                  handleClickOpenModalEditSupport={handleClickOpenModalEditSupport}
                  handleDeleteSUpport={handleDeleteSUpport}
                  getDocumentIconFromExtension={getDocumentIconFromExtension}
                  categoryId={props.categoryId}
                  paginateAndSorting={props.paginateAndSorting}
                  elementPerPage={props.elementPerPage}
                  currentPage={props.currentPage}
                  setSortColumnDocument={props.setSortColumn}
                  setSortOrder={props.setSortOrder}
                  setFilteredDocuments={props.setFilteredDocuments}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      <Modal isOpen={openModalViewer} toggle={() => handleClickOpenModalViewer(new SupportDto())} size="xl" className={styles["support_modal"]}>
        <ModalHeader toggle={() => setOpenModalViewer(!openModalViewer)}></ModalHeader>
        <ModalBody>
          <FileViewer src={urlSupport} width={"100%"} height={(window.innerHeight*0.83)+"px"} />
        </ModalBody>
      </Modal>
      <Modal isOpen={openModalEditSupport} size="lg">
        <ModalBody className={styles["modal-body"]}>
          <div>
            <h6 className={styles["title-model"] + " p-20"}>{props.t("title_update_document")}</h6>
          </div>
          <AddSupport
            className={styles["modal-body"]}
            resetAllFieldSearch={resetAllFieldSearch}
            getListSupport={handleGetListSupport}
            support={editSupport}
            closeToggle={handleClickOpenModalEditSupport}
            path={props.path}
          ></AddSupport>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default translate(Documents);
